$(document).on('click','.add_pickup',function(){ 
$.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: 43278780006632
},
  dataType: 'json', 
 success: function (data) { 
  $('#CartCount span:first').text(data.quantity);
 } 
 });
})

// $(document).on('click','.add_combi',function(){ 
// $.ajax({
// type: 'POST',
// url: '/cart/add.js',
// data: {
//   quantity: 1,
//   id: 41952396869781
// },
//   dataType: 'json', 
//  success: function (data) { 
//   $('#CartCount span:first').text(data.quantity);
//  } 
//  });
// })
